import { flatMap, flatMapDeep } from 'lodash-es';

import {
  extractActiveConnectionCountByEntityTypeId
} from 'entity/helpers/connections-count-helpers';
import { isNilOrEmpty } from 'helpers';

import { EntityWithMapViewDetailsFragment } from 'generated/graphql';

import { IGeocodeInfo } from './address-has-good-geocode';
import { EntityMarkerGEOJsonType } from './EntityMarkerGEOJsonType';
import { IEntityMarkerFeatureFactory } from './IEntityMarkerFeatureFactory';
import { makePointFeature } from './make-geojson-point-feature';

export class EntityMarkerFeatureMakerForConnections
  implements IEntityMarkerFeatureFactory<EntityWithMapViewDetailsFragment> {

  constructor(
    private defaultEntityTypeId: string,
    private _extractEntityAddressesFn: (entity: any) => Array<any>
  ) {
  }

  buildMarkerFeatures(
    entity: EntityWithMapViewDetailsFragment,
    addressFilterFn: <T extends IGeocodeInfo> (addresses: T[]) => T[],
  ): EntityMarkerGEOJsonType[] {

    const addresses = addressFilterFn(this._extractEntityAddressesFn(entity));
    const squareBadgeCount = extractActiveConnectionCountByEntityTypeId(this.defaultEntityTypeId, entity);

    return addresses.map(addr => makePointFeature(
      [addr.longitude, addr.latitude],
      {
        currentAssessmentLevel: entity.currentAssessmentLevel,
        entityIds: [entity.id],
        icon: entity.entityType.icon,
        address: addr,
        counterBadgeText: squareBadgeCount
      }
    )
    );

  }

  createdMergedPoint(markers: EntityMarkerGEOJsonType[]): EntityMarkerGEOJsonType {
    // Returns a flattened array of the entityIds in the features
    const entityIds = flatMapDeep(
      flatMap(markers, pf => pf.properties?.data),
      props => props.entityIds
    );

    // Grab the coordinates from the first item since they
    // should be the same.
    const coordinates = markers[0].geometry.coordinates;

    // Sum all the square badges in the markers
    const connectionsSum = flatMapDeep(
      flatMap(markers, pf => pf.properties?.data),
      props => props.counterBadgeText
    )
      .filter(sqbc => !isNilOrEmpty(sqbc))
      .reduce((a, b) => a + b, 0);

    // Grab the address from the first item since they should be
    // sthe same
    const address = markers[0].properties?.data.address;

    return makePointFeature(
      coordinates, {
      entityIds,
      icon: null,
      counterBadgeText: connectionsSum > 0 ? connectionsSum : null,
      address,
      currentAssessmentLevel: null
    }
    );
  }

}
